import React from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner} from "reactstrap";
import IconLabel from "./IconLabel";
import {ChevronLeftIcon} from "./icons";

/**
 * @param {{
 *   isOpen: boolean,
 *   title: string,
 *   message: string,
 *   confirmLabel: string,
 *   confirmIcon?: React.ComponentType,
 *   color?: string,
 *   busy?: boolean,
 *   onConfirm: () => void,
 *   onCancel: () => void,
 * }} props
 */
const ConfirmModal = ({
    isOpen,
    title,
    message,
    confirmLabel,
    confirmIcon: ConfirmIcon,
    color = "primary",
    busy = false,
    onConfirm,
    onCancel,
}) => (
    <Modal isOpen={isOpen} toggle={busy ? undefined : onCancel} fade={false} centered>
        <ModalHeader toggle={busy ? undefined : onCancel}>{title}</ModalHeader>
        <ModalBody>{message}</ModalBody>
        <ModalFooter>
            <Button color="secondary" outline onClick={onCancel} disabled={busy}>
                <IconLabel icon={<ChevronLeftIcon />}>Voltar</IconLabel>
            </Button>
            <Button color={color} onClick={onConfirm} disabled={busy}>
                {busy ? (
                    <Spinner size="sm" />
                ) : ConfirmIcon ? (
                    <IconLabel icon={<ConfirmIcon />}>{confirmLabel}</IconLabel>
                ) : (
                    confirmLabel
                )}
            </Button>
        </ModalFooter>
    </Modal>
);

export default ConfirmModal;
